import { gql } from "@apollo/client";

export type PublishStatusData = {
  getBranches: { id: string }[];
  getProductCount: number;
  getPartner: {
    id: string;
    status: string | null;
    logo: string | null;
    url_name: string | null;
  };
  getConnectAccount: {
    id: string;
    status: string;
    charges_enabled: boolean;
    payouts_enabled: boolean;
  } | null;
};

export const GET_PUBLISH_STATUS = gql`
  query GetPublishStatus {
    getBranches {
      id
    }
    getProductCount
    getPartner {
      id
      status
      logo
      url_name
    }
    getConnectAccount {
      id
      status
      charges_enabled
      payouts_enabled
    }
  }
`;

export const PUBLISH_PARTNER = gql`
  mutation PublishPartner {
    publishPartner {
      id
      status
    }
  }
`;
